import GiftProductListContainer from './GiftProductListContainer';
export default GiftProductListContainer;
